import {QueryClient} from '@tanstack/query-core';

import {ONE_HOUR_MS} from '@/consts';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // after 1h, requests are considered stale
      // this means that refetching is only automatically triggered after this time
      staleTime: ONE_HOUR_MS,
    },
  },
});
